import useCountdown from "@/hooks/useCountdown";
import { Timer } from "lucide-react";

export default function CountdownPill({ targetIso, className = "" }) {
  const { h, m, s, expired } = useCountdown(targetIso);
  if (expired) {
    return (
      <div data-testid="countdown-expired" className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-gray-800 text-white text-[10px] font-bold uppercase tracking-wider ${className}`}>
        <Timer className="h-3 w-3" /> Sold Out
      </div>
    );
  }
  const pad = (n) => String(n).padStart(2, "0");
  return (
    <div data-testid="countdown-pill" className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#EF4444] text-white text-[11px] timer-pill font-bold ${className}`}>
      <Timer className="h-3 w-3" />
      {h > 0 && <span>{pad(h)}:</span>}
      <span>{pad(m)}:{pad(s)}</span>
    </div>
  );
}
